import useErrorHandler from "../FormErrorHandler";
import {
  TextInput,
  FormInputRow,
  FormSection,
  FormHeader,
  RadioInput,
  TextField,
  AddressInput,
} from "../../FormInput/FormInput";
import { validateZipcode } from "../Validations";

const GettingStarted = ({ formData, handleInputChange, validateForm }) => {
  const { error, addError, clearError, hasError } = useErrorHandler();

  const validate = async (formData) => {
    clearError();

    if (!formData.lossInformation.StreetAddress) {
      addError({ StreetAddress: "Address is required" });
    }
    if (!formData.lossInformation.City) {
      addError({ City: "City is required" });
    }
    if (!formData.lossInformation.ZipCode) {
      addError({ ZipCode: "Zipcode is required" });
    } else{
      if (isNaN(parseInt(formData.lossInformation.ZipCode)) || formData.lossInformation.ZipCode.toString().length != 5)
        addError({ ZipCode: "Enter a 5 digit zip code" });
      else {
        const state = await validateZipcode(formData.lossInformation.ZipCode)
        if(!state)
          addError({ ZipCode: "Enter a valid zip code" });
        else
          handleInputChange("State", state, "lossInformation");
      } 
    }

    if (!formData.lossInformation.descriptionOfAccident) {
      addError({ descriptionOfAccident: "Please provide a description" });
    }

    if (!formData.lossInformation.policeContacted) {
      addError({ policeContacted: "This field is required" });
    }

    if (!formData.vehicleInfo.describeDamage) {
      addError({ describeDamage: "Please provide a description" });
    }

    if (!formData.vehicleInfo.isTowed) {
      addError({ isTowed: "This field is required" });
    }

    return !hasError();
  };

  validateForm.current = validate;

  const handlePoliceSelection = (field, value, parent) => {
    handleInputChange(field, value, parent)
    if(value == "No"){
      handleInputChange("policeDistrict", null, parent)
      handleInputChange("reportNumber", null, parent)
    }
  }

  return (
    <div>
      <FormHeader>LOSS INFORMATION</FormHeader>
      <FormSection>
        <FormInputRow header="Address of Loss Location*" sameLine={true}>
          <AddressInput
            addressData={formData.lossInformation}
            handleInputChange={handleInputChange}
            parentField="lossInformation"
            error={error}
          />
        </FormInputRow>

        <FormInputRow header="Describe in detail how this loss occured:*">
          <TextField
            fieldName="descriptionOfAccident"
            value={formData.lossInformation.descriptionOfAccident}
            handleInputChange={handleInputChange}
            parentField="lossInformation"
            error={error}
          />
        </FormInputRow>

        <FormInputRow header="Did the police come to the scene?*">
          <RadioInput
            fieldName="policeContacted"
            value={formData.lossInformation.policeContacted}
            handleInputChange={handlePoliceSelection}
            parentField="lossInformation"
            sameLine={true}
            error={error}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
          />
        </FormInputRow>

        {formData.lossInformation.policeContacted == "Yes" && 
          <>
            <FormInputRow header="Police District/Township:">
              <TextInput
                fieldName="policeDistrict"
                value={formData.lossInformation.policeDistrict}
                handleInputChange={handleInputChange}
                parentField="lossInformation"
              />
            </FormInputRow>

            <FormInputRow header="Case/Report Number:">
              <TextInput
                fieldName="reportNumber"
                value={formData.lossInformation.reportNumber}
                handleInputChange={handleInputChange}
                parentField="lossInformation"
              />
            </FormInputRow>
          </>
        }
        <FormSection
          header={"Your Vehicle Damage Information"}
          setPadding={false}
        >
          <FormInputRow header="Please describe the damage to your vehicle:*">
            <TextField
              fieldName="describeDamage"
              value={formData.vehicleInfo.describeDamage}
              handleInputChange={handleInputChange}
              parentField="vehicleInfo"
              error={error}
            />
          </FormInputRow>
          <FormInputRow header="Did the vehicle airbags deploy?">
            <RadioInput
              fieldName="isAirbagDeployed"
              value={formData.vehicleInfo.isAirbagDeployed}
              handleInputChange={handleInputChange}
              parentField="vehicleInfo"
              sameLine={true}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </FormInputRow>
          <FormInputRow header="Is the vehicle in a condition where it cannot be driven?">
            <RadioInput
              fieldName="isDrivable"
              value={formData.vehicleInfo.isDrivable}
              handleInputChange={handleInputChange}
              parentField="vehicleInfo"
              sameLine={true}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </FormInputRow>
          <FormInputRow header="Is the roof of this vehicle buckled and/or did the vehicle roll over?">
            <RadioInput
              fieldName="isRoofBuckled"
              value={formData.vehicleInfo.isRoofBuckled}
              handleInputChange={handleInputChange}
              parentField="vehicleInfo"
              sameLine={true}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </FormInputRow>
          <FormInputRow header="Was this vehicle towed?*">
            <RadioInput
              fieldName="isTowed"
              value={formData.vehicleInfo.isTowed}
              handleInputChange={handleInputChange}
              parentField="vehicleInfo"
              sameLine={true}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              error={error}
            />
          </FormInputRow>
        </FormSection>
      </FormSection>
    </div>
  );
};

export default GettingStarted;
